import {useMemo} from "react";

interface CardValidationParams {
  cardNumberData: { valid: boolean };
  securityCodeData: { valid: boolean };
  expirationMonth?: string | null;
  expirationYear?: string | null;
  cardType: string;
}

interface CardValidationResult {
    isEmptyDate: boolean;
    isValidDate: boolean;
    isValidCard: boolean;
}

export const useCardValidation = ({
    cardNumberData,
    securityCodeData,
    expirationMonth = null,
    expirationYear = null,
    cardType
}: CardValidationParams): CardValidationResult => {
    const EXPECTED_YEAR_LENGTH = 4;

    return useMemo(() => {
        const isEmptyDate = !expirationMonth && !expirationYear;

        let isValidYear = false;
        let isValidMonth = false;

        if (!isEmptyDate) {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth() + 1;

            isValidYear = parseInt(expirationYear) >= currentYear
                && expirationYear.length == EXPECTED_YEAR_LENGTH;

            const intMonth = parseInt(expirationMonth);

            isValidMonth = intMonth > 0
                && intMonth <= 12
                && (parseInt(expirationYear) != currentYear || intMonth >= currentMonth);
        }


        const isValidDate = isValidMonth && isValidYear;

        return {
          isEmptyDate,
          isValidDate,
          isValidCard:
              cardNumberData.valid
              && securityCodeData.valid
              && isValidDate
              && Boolean(cardType)
        };
    }, [cardType, expirationMonth, expirationYear, cardNumberData.valid, securityCodeData.valid]);
};
